import isInteger from 'lodash/isInteger';
import { QUANTITY_INPUT } from 'jl-design-system/form/fields';

export function calcMaxValueFromAvailability(selectMaxThreshold, stockLevel, quantityLimit) {
  const limit = parseInt(quantityLimit, 10);
  if (isInteger(limit)) {
    return limit;
  }

  const stock = parseInt(stockLevel, 10);
  if (isInteger(stock)) {
    return stock > selectMaxThreshold ? 0 : stock;
  }
  return 0;
}

export const ITEM_QUANTITY_FORM = 'itemQuantityForm';
export function getFormId(id) {
  return `${ITEM_QUANTITY_FORM}-${id}`;
}

export default function getItemQuantityFormConfig({
  item,
  changeHandler,
  isItemFabric = false,
  maxValue = 0,
  isTradePlace,
}) {
  const { id, availability: { stockLevel, quantityLimit } = {} } = item;
  const selectMaxThreshold = QUANTITY_INPUT.selectMaxThreshold;
  const selectMaxValue = maxValue || calcMaxValueFromAvailability(selectMaxThreshold, stockLevel, quantityLimit);

  return {
    id: getFormId(id),
    fields: [{
      ...QUANTITY_INPUT,
      props: {
        id: `itemQuantity-${id}`,
        name: `itemQuantity-${id}`,
        required: true,
        handleChange: changeHandler,
        unitText: isItemFabric ? 'metre(s)' : '',
        selectMaxValue: isTradePlace ? 1 : selectMaxValue,
        quantity: item.quantity,
        textInputChangeDebounceMsecs: 500,
        instruction: isTradePlace ? 'Limited to one per order' : '',
      },
    }],
  };

}
